import * as msg from '../../helpers/console'
import chartRender from '../../components/chartRender'

const init = () => {
  msg.success('DashboardController', 'Ready!')
  new chartRender().init()
}

export default init
